import { GreenCtaButton } from '../../components/atomic/buttons/green_cta_button/GreenCtaButton';
import textImg from '../texts/button_text.png';

type ButtonProps = {
  onClick?: () => void;
};

/** From Figma button_take (141:17396) — claim sticker CTA. */
export function Button({ onClick }: ButtonProps) {
  return (
    <GreenCtaButton
      textSrc={textImg}
      ariaLabel="Забрать"
      onClick={onClick}
      left={266.5845}
      width={547.191}
      gradient={{ sizeX: 364.33, sizeY: 977.58, atX: 273.6, atY: 86.5 }}
      flash={{ left: 510.9155, top: 12.42 }}
      textSize={{ width: 274, height: 107 }}
    />
  );
}
